import { useModel } from "@stem-sims/nexus"
import { PulseLoader } from "react-spinners"
import { Col, Row } from "react-bootstrap"
import { useCallback } from "react"
import { useParams } from "react-router"
import { createReviewGroup, deleteReviewGroup, getBlock, updateBlock } from "shared/routes/reviewRoutes"
import { toast } from "react-toastify"
import EditingListPane from "../EditingListPane"
import EditingItemPane from "../EditingItemPane"

export default function EditingBlock() {
     const { blockId } = useParams() as { blockId: string }

    const { loading, response: block, refreshModel: refresh } = useModel({
        model: getBlock,
        props: blockId,
    })

    const onUpdateBlockCallback = useCallback(async (values: { block: string }) => {
        try {
            await updateBlock({ blockId, block: values.block })
        } catch (err) {
            toast.error(err?.response?.data ?? "Something went wrong updating block information.")
        }
        refresh()
    }, [refresh, blockId])

    const createReviewGroupCallback = useCallback(async () => {
        try {
            const message = await createReviewGroup({ blockId })
            toast.success(message)
            refresh()
        } catch (err) {
            toast.error(err)
        }
    }, [refresh, blockId])

    const deleteReviewGroupCallback = useCallback(async (values: { id: string }) => {
        try {
            const message = await deleteReviewGroup(values.id)
            toast.success(message)
            refresh()
        } catch (err) {
            toast.error(err)
        }
    }, [refresh])

    if (loading || !block) {
        return <>
            <PulseLoader />
        </>
    }

    return <>
        <Row>
            <Col xs={6}>
                <EditingItemPane
                    data={{ ...block }}
                    fields={[
                        { fieldName: "block", inputType: "input" },
                    ]}
                    itemTypeName="block"
                    onSubmit={onUpdateBlockCallback}
                />
            </Col>
            <Col xs={6}>
                <h4>Review Groups</h4>
                <EditingListPane
                    parent={null}
                    items={block.reviewGroups.map((group) => ({ id: group.groupId, name: group.name }))}
                    itemType="block-review-group"
                    createItem={createReviewGroupCallback}
                    updateItem={null}
                    deleteItem={deleteReviewGroupCallback}
                />
            </Col>
        </Row>
    </>
}
